export const userStateAction = {
  SET_USER_STATE: "SET_USER_STATE",
  SAVE_USER_DATA: "SAVE_USER_DATA",
  USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  USER_LOGOUT_REQUEST: "USER_LOGOUT_REQUEST",
  USER_LOGOUT_SUCCESS: "USER_LOGOUT_SUCCESS",
  SELECT_USER_SCOOTER: "SELECT_USER_SCOOTER",
  SAVA_TEMPORARY_STORAGE: "SAVA_TEMPORARY_STORAGE",
  FETCH_OCR_REQUEST: "FETCH_OCR_REQUEST",
  FETCH_CUSTOMER_REQUEST: "FETCH_CUSTOMER_REQUEST",
  SET_RECAPTCHA_STATUS: "SET_RECAPTCHA_STATUS",
  SET_IS_GLOBE: "SET_IS_GLOBE",
  SET_DATA_COMPANY: "SET_DATA_COMPANY",

  setUserState: (data) => ({
    type: userStateAction.SET_USER_STATE,
    payload: data,
  }),

  setIsGlobe: (data) => ({
    type: userStateAction.SET_IS_GLOBE,
    payload: data,
  }),

  setDataCompany: (data) => ({
    type: userStateAction.SET_DATA_COMPANY,
    payload: data,
  }),

  userLogin: (data) => ({
    type: userStateAction.USER_LOGIN_REQUEST,
    payload: data,
  }),

  userLogout: () => ({
    type: userStateAction.USER_LOGOUT_REQUEST,
  }),

  selectUserScooter: (name, value) => ({
    type: userStateAction.SELECT_USER_SCOOTER,
    payload: { name: name, value: value },
  }),

  saveTemporaryStorage: (name, data, num) => ({
    type: userStateAction.SAVA_TEMPORARY_STORAGE,
    payload: { name: name, data: data, num: num },
  }),

  fetchOCRRequest: (name, type, image64, loading, resolve) => ({
    type: userStateAction.FETCH_OCR_REQUEST,
    payload: { name: name, type: type, image64: image64, loading: loading, resolve },
  }),

  setRecaptchaStatus: (status) => ({
    type: userStateAction.SET_RECAPTCHA_STATUS,
    payload: { recaptcha: status },
  }),
}
